<template>
  <v-module :title="title">
    <v-row>
      <v-field-text v-model="nom" label="Nom" name="exploitant_nom" :readonly="readonly" required @input='update' v-validate='"required"'/>
      <v-field-text v-model="prenom" label="Prénom" name="exploitant_prenom" :readonly="readonly" required @input='update' v-validate='"required"'/>
    </v-row>
    <v-row>
      <v-field-text v-model="email" label="Email" name="exploitant_email" :readonly="readonly" required @input='update' v-validate='"required|email"'/>
    </v-row>
    <slot />
  </v-module>
</template>

<script>

export default {
  name: 'form-exploitant',

  inject: ['$validator'],

  props: {
    title: {
      type: String,
      required: true
    },
    exploitant: {
      type: Object,
      default: function () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      nom: this.exploitant.nom,
      prenom: this.exploitant.prenom,
      email: this.exploitant.email
    }
  },

  methods: {
    update () {
      this.$emit('input', this.$data)
    }
  }
}
</script>
